// extracted by mini-css-extract-plugin
export default {"page":"Terms_page__BPjHK","title":"Terms_title__6uWSI","updated":"Terms_updated__kO+go"};